/* @flow */
import * as React from "react";

export const HANDLE_SIZE = 22;

const styles = {
  handle: {
    borderRadius: "50%",
    height: HANDLE_SIZE,
    transform: "translate(-50%)",
    width: HANDLE_SIZE,
  },
  wrapper: {
    width: 0,
  },
};

type Props = {
  color: string,
  isMinimum: boolean,
  tooltip: React.Node,
  role: string,
  "aria-valuenow": number,
  "aria-valuemin": number,
  "aria-valuemax": number,
  "aria-valuetext": string,
};

export default class Handle extends React.Component<Props> {
  render() {
    const {
      color,
      isMinimum,
      tooltip,
      role,
      "aria-valuenow": ariaValuenow,
      "aria-valuemin": ariaValuemin,
      "aria-valuemax": ariaValuemax,
      "aria-valuetext": ariaValuetext,
    } = this.props;

    return (
      <div
        data-component-name="Handle"
        style={styles.wrapper}
        role={role}
        aria-valuenow={ariaValuenow}
        aria-valuemin={ariaValuemin}
        aria-valuemax={ariaValuemax}
        aria-valuetext={ariaValuetext}
      >
        <div
          style={{
            ...styles.handle,
            backgroundColor: color,
            ...(isMinimum
              ? {
                  backgroundColor: "white",
                  border: `2px solid ${color}`,
                }
              : null),
          }}
        >
          {tooltip}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/Slider/Handle.jsx